import { useContext } from 'react';
import { OrganizationConfigContext } from '../../context/OrganizationConfigContext';
import { NavLink } from 'react-router-dom';
import styles from './LinkList.module.scss';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

export const LinkList = () => {
  const { t } = useTranslation();
  const { cloudLicense, cloudLink } = useContext(OrganizationConfigContext);

  const canNextcloud = cloudLicense && cloudLink;

  return (
    <div className={styles['link-list']}>
      <NavLink
        to={canNextcloud ? `https://${cloudLink}` : ''}
        className={classNames(styles.link, { [styles.disabled]: !canNextcloud })}
        target='_blank'
      >
        {canNextcloud ? t('common.nextcloud') : `${t('common.nextcloud')} (${t('links.notAvailable')})`}
      </NavLink>
    </div>
  );
};
